module.exports = __webpack_public_path__ + "img/map-light.dd35c365.svg";